import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const postUserProfile = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.USER_MANAGEMENT.POST_USER_PROFILE(
      data.iscustomlogin
    ),
    data
  );
};

export default postUserProfile;
